import Typography from "@mui/material/Typography";
import { makeStyles } from "@mui/styles";
import React from "react";

const useStyle = makeStyles((theme) => ({
  root: {
    margin: "40px 0px",
  },
  title: {
    fontSize: "1.5rem !important",
    fontWeight: "500 !important",
    marginBottom: "20px !important",
    textAlign: "center",
  },
  content: {
    fontSize: "1rem",
    marginBottom: "20px !important",
  },
  subtitle: {
    fontSize: "1rem",
    marginBottom: "20px !important",
    fontWeight: "500 !important",
  },

  icon: {
    marginRight: 10,
    position: "relative",
    top: 5,
  },
  select: {
    marginBottom: 30,
  },
  footer: {
    marginTop: "-80px",
  },
  center: {
    textAlign: "center",
  },
}));

const PersonalTCBangla = () => {
  const classes = useStyle();

  return (
    <div>
      <Typography className={classes.title}>
        অ্যাকাউন্ট হোল্ডার নিয়ম (ব্যক্তিগত অ্যাকাউন্ট)
      </Typography>
      <p className={classes.center}>
        {" "}
        এই শর্তাবলী এবং নিয়মাবলী এসটি পে পার্সোনাল অ্যাকাউন্ট এবং সংশ্লিষ্ট
        সেবার ব্যবহারের জন্য প্রযোজ্য। দয়া করে এটি মনোযোগ দিয়ে পড়ুন।
        রেজিস্ট্রেশনের সময় "Terms and Conditions" বক্সে টিক দিয়ে এবং এসটি পে
        ব্যবহার করে, আপনি এই শর্তাবলীর সাথে সম্মত হচ্ছেন। যদি আপনি সম্মত না হন,
        তাহলে রেজিস্ট্রেশন, প্রবেশ বা প্ল্যাটফর্ম ব্যবহার করা থেকে বিরত
        থাকুন।{" "}
      </p>{" "}
      <h4>১. সংজ্ঞা</h4>{" "}
      <ul>
        {" "}
        <li>
          “এসটি পে” বলতে গ্রিন অ্যান্ড রেড টেকনোলজিস লিমিটেড কর্তৃক পরিচালিত
          ডিজিটাল ওয়ালেট এবং পেমেন্ট সেবা বোঝায়, যা বাংলাদেশ ব্যাংক থেকে PSP
          লাইসেন্সপ্রাপ্ত।
        </li>{" "}
        <li>
          “ইউজার” / “আপনি” বলতে সেই ব্যক্তিকে বোঝায় যিনি পার্সোনাল এসটি পে
          অ্যাকাউন্ট খোলেন ও ব্যবহার করেন।
        </li>{" "}
        <li>
          “সেবা” বলতে এসটি পে প্ল্যাটফর্মের সকল ফিচার, টুলস এবং ফাংশনালিটিকে
          বোঝায়।
        </li>{" "}
        <li>
          “KYC” বলতে গ্রাহক যাচাইয়ের জন্য প্রয়োজনীয় নিয়ন্ত্রক প্রক্রিয়াকে
          বোঝায়।
        </li>{" "}
        <li>
          “ই-মানি” বলতে এসটি পে এর উপর দাবির ভিত্তিতে ইলেকট্রনিকভাবে সংরক্ষিত
          অর্থমূল্যকে বোঝায়।
        </li>{" "}
      </ul>{" "}
      <h4>২. যোগ্যতা</h4> <p>আপনার অবশ্যই:</p>{" "}
      <ul>
        {" "}
        <li>কমপক্ষে ১৮ বছর বয়সী হতে হবে;</li>{" "}
        <li>
          বাংলাদেশের নাগরিক হতে হবে (এসটি পে অনুমোদিত হলে ব্যতিক্রম হতে পারে);
        </li>{" "}
        <li>সঠিক পরিচয়পত্র প্রদান ও প্রয়োজনীয় KYC যাচাই পাস করতে হবে;</li>{" "}
        <li>
          অ্যাকাউন্ট শুধুমাত্র আইনসম্মত এবং পার্সোনাল কাজে ব্যবহার করতে হবে।
        </li>{" "}
      </ul>{" "}
      <h4>৩. অ্যাকাউন্ট রেজিস্ট্রেশন ও নিরাপত্তা</h4>{" "}
      <ul>
        {" "}
        <li>
          আপনার ক্রেডেনশিয়াল (PIN, OTP, পাসওয়ার্ড) রক্ষা করার দায়িত্ব আপনার।
        </li>{" "}
        <li>
          আপনার অবহেলার কারণে অগ্রাধিকারহীন প্রবেশের ফলে ক্ষতির জন্য এসটি পে
          দায়ী নয়।
        </li>{" "}
        <li>সন্দেহজনক কোনো ব্রিচ হলে এসটি পে-কে অবিলম্বে জানাতে হবে।</li>{" "}
      </ul>{" "}

      <h4>৪. নমিনী (মনোনীত ব্যক্তি)</h4>{" "}
      <p>নমিনী হলো এমন একজন যাকে এস টি পে ব্যবহারকারী মনোনীত করে, যার কাছে ব্যবহারকারীর মৃত্যু হলে ওয়ালেটের তহবিল পাওয়ার অধিকার থাকবে। প্রতিটি সক্রিয় ওয়ালেট ব্যবহারকারী সর্বোচ্চ 2 জন নমিনী যোগ করতে পারবেন, এবং মনোনীত ব্যক্তির তথ্য ৩০ দিনের পর আপডেট করা যাবে। একই ব্যক্তিকে একই ওয়ালেটের জন্য একবারের বেশি মনোনীত ব্যক্তি হিসেবে যোগ করা যাবে না, তবে সে অন্য ব্যবহারকারীর ওয়ালেটে নমিনী হতে পারবে।</p>{" "}

      <h4>৫. অনুমোদিত ব্যবহার</h4>{" "}
      <ul>
        {" "}
        <li>
          এসটি পে পার্সোনাল অ্যাকাউন্ট শুধুমাত্র ব্যক্তি পর্যায়ে, অ-কমার্শিয়াল
          ব্যবহারের জন্য।
        </li>{" "}
        <li>
          ব্যবসায়িক, হাই-ভলিউম লেনদেন বা মার্চেন্ট কার্যকলাপের জন্য পূর্ব লিখিত
          অনুমোদন প্রয়োজন।
        </li>{" "}
      </ul>{" "}
      <h4>৬. নিষিদ্ধ কার্যক্রম</h4>{" "}
      <p>আপনি নিম্নলিখিত কার্যক্রমে জড়িত হতে পারবেন না:</p>{" "}
      <ul>
        {" "}
        <li>আইন বা বিধিনিষেধ লঙ্ঘন করা;</li>{" "}
        <li>মানি লন্ডারিং, প্রতারণা বা সন্ত্রাসে অর্থায়ন;</li>{" "}
        <li>
          এসটি পে ব্যবহার করে জুয়া, প্রাপ্তবয়স্ক বিষয়বস্তু, মাদক বা অবৈধ
          দ্রব্য ক্রয়-বিক্রয়;
        </li>{" "}
        <li>এসটি পে সিস্টেমে হস্তক্ষেপ বা অনুমোদনহীন প্রবেশ।</li>{" "}
      </ul>{" "}
      <h4>৭. লেনদেন পর্যবেক্ষণ ও AML কমপ্লায়েন্স</h4>{" "}
      <ul>
        {" "}
        <li>
          সকল লেনদেন বাংলাদেশ ব্যাংক এবং BFIU এর AML/CFT নির্দেশিকার অধীনে
          পর্যবেক্ষণ করা হয়।
        </li>{" "}
        <li>
          সন্দেহজনক কার্যকলাপ এসটি পে পূর্ব বিজ্ঞপ্তি ছাড়াই নিয়ন্ত্রক সংস্থাকে
          জানাতে পারে।
        </li>{" "}
        <li>
          কমপ্লায়েন্সের কারণে লেনদেন বিলম্ব, স্থগিত বা বাতিল হতে পারে।
        </li>{" "}
      </ul>{" "}
      <h4>৮. সেবা সীমা, হোল্ড ও সাসপেনশন</h4>{" "}
      <ul>
        {" "}
        <li>
          আপনার যাচাইয়ের স্তর ও লেনদেনের ধরণের উপর ভিত্তি করে সীমা প্রযোজ্য হতে
          পারে।
        </li>{" "}
        <li>
          এসটি পে নিম্নলিখিত অবস্থায় আপনার অ্যাকাউন্ট স্থগিত বা হোল্ড করতে পারে:{" "}
          <ul>
            {" "}
            <li>নিয়ন্ত্রক তদন্ত চলাকালে;</li>{" "}
            <li>
              প্রতারণা, সন্দেহজনক কার্যকলাপ বা নিরাপত্তা লঙ্ঘনের ক্ষেত্রে;
            </li>{" "}
            <li>শর্তাবলী লঙ্ঘনের ক্ষেত্রে।</li>{" "}
          </ul>{" "}
        </li>{" "}
      </ul>{" "}
      <h4>৯. ইলেকট্রনিক মানি (ই-মানি)</h4>{" "}
      <ul>
        {" "}
        <li>
          এসটি পে ইলেকট্রনিক মানি ইস্যুয়ার হিসাবে বাংলাদেশ ব্যাংকের নিয়ম
          অনুযায়ী ওয়ালেট ব্যালেন্স পরিচালনা করে।
        </li>{" "}
        <li>
          ওয়ালেট ব্যালেন্স ব্যাংক ডিপোজিট নয় এবং এর উপর কোনো সুদ প্রযোজ্য নয়।
        </li>{" "}
        <li>
          ই-মানি এসটি পে এর কাছে সমমানের অর্থের বিনিময়ে ইস্যু করা হয় এবং
          নিয়ন্ত্রক মান অনুযায়ী সুরক্ষিত থাকে।
        </li>{" "}
        <li>
          আপনার ব্যালেন্স এসটি পে প্রদত্ত সেবার সীমার মধ্যে ব্যবহারযোগ্য স্টোর
          ভ্যালু হিসেবে স্বীকৃত।
        </li>{" "}
      </ul>{" "}
      <h4>১০. অর্থ যোগ (টপ-আপ/ফান্ড লোড)</h4>{" "}
      <ul>
        {" "}
        <li>
          ব্যাংক অ্যাকাউন্ট, ডেবিট/ক্রেডিট কার্ড, এমএফএস বা অনুমোদিত চ্যানেলের
          মাধ্যমে অর্থ যোগ করা যেতে পারে।
        </li>{" "}
        <li>
          টপ-আপ সীমা প্রযোজ্য হতে পারে এবং তা KYC স্ট্যাটাস অনুযায়ী নির্ধারিত
          হবে।
        </li>{" "}
        <li>
          তৃতীয় পক্ষের সমস্যার কারণে লোডিং ব্যর্থ হলে, এসটি পে প্রয়োজনীয়
          সমন্বয় করবে কিন্তু নিয়ন্ত্রণের বাইরে কোনো দেরির জন্য দায়ী নয়।
        </li>{" "}
      </ul>{" "}
      <h4>১০A. ব্যাংক অ্যাকাউন্ট যাচাই ও ওয়ালেট লিমিট আপগ্রেড</h4>{" "}
      <ul>
        {" "}
        <li>
          সর্বোচ্চ লেনদেন সীমা ও উন্নত সেবা পেতে ব্যবহারকারীকে নিজের নামে
          নিবন্ধিত ব্যাংক অ্যাকাউন্ট লিঙ্ক ও যাচাই করতে হবে।
        </li>{" "}
        <li>
          যাচাই সম্পন্ন না হওয়া পর্যন্ত ব্যবহার সর্বাধিক মাসিক BDT ১০,০০০
          পর্যন্ত সীমাবদ্ধ থাকবে।
        </li>{" "}
        <li>যাচাই প্রক্রিয়া ১-৩ কর্মদিবসের মধ্যে সম্পন্ন হবে।</li>{" "}
        <li>
          সফল যাচাইয়ের পর ব্যবহারকারীর ওয়ালেট সীমা স্বয়ংক্রিয়ভাবে সর্বাধিক
          সীমায় উন্নীত হবে।
        </li>{" "}
        <li>
          যাচাই প্রক্রিয়ায় সন্দেহজনক কার্যকলাপ বা তথ্যের অমিল হলে এসটি পে যাচাই
          বাতিল বা স্থগিত করার অধিকার রাখে।
        </li>{" "}
      </ul>
      <h4>১১. অর্থ প্রেরণ / গ্রহণ</h4>{" "}
      <ul>
        {" "}
        <li>
          আপনি অন্যান্য এসটি পে ব্যবহারকারীর সাথে অর্থ প্রেরণ ও গ্রহণ করতে
          পারবেন।
        </li>{" "}
        <li>লেনদেন নিশ্চিত হওয়ার পর তা চূড়ান্ত ধরা হবে।</li>{" "}
        <li>
          ট্রান্সফার করার আগে প্রাপকের তথ্য যাচাই করার দায়িত্ব সম্পূর্ণ আপনার।
        </li>{" "}
      </ul>{" "}
      <h4>১২. ব্যাংক / এমএফএস / ভিসা ডেবিট-এ ট্রান্সফার</h4>{" "}
      <ul>
        {" "}
        <li>
          এসটি পে লিঙ্ককৃত ব্যাংক অ্যাকাউন্ট, ভিসা ডেবিট বা এমএফএস এ ট্রান্সফার
          করার সুযোগ দিতে পারে, যা সেবার প্রাপ্যতা ও ফি-এর উপর নির্ভর করবে।
        </li>{" "}
        <li>
          লেনদেন নির্দিষ্ট কাট-অফ টাইম, কমপ্লায়েন্স চেক ও চার্জের অধীনে হবে।
        </li>{" "}
        <li>
          তৃতীয় পক্ষ বা নেটওয়ার্ক সমস্যার কারণে দেরির জন্য এসটি পে দায়ী নয়।
        </li>{" "}
      </ul>{" "}
      <h4>১৩. রিফান্ড ও বাতিলকরণ নীতি</h4>{" "}
      <ul>
        {" "}
        <li>
          ব্যর্থ বা ভুল লেনদেনের ক্ষেত্রে অভ্যন্তরীণ তদন্তের পর রিফান্ড প্রদান
          করা হবে।
        </li>{" "}
        <li>
          মার্চেন্ট বা বিলারের সাথে লেনদেনের ক্ষেত্রে তাদের রিফান্ড নীতি
          প্রযোজ্য হবে।
        </li>{" "}
        <li>
          ব্যবহারকারী অ্যাকাউন্ট বন্ধের অনুরোধ করতে পারবেন, শর্ত থাকে কোনো
          বকেয়া বা হোল্ড থাকা যাবে না।
        </li>{" "}
      </ul>{" "}
      <h4>১৩ক. লেনদেন রিভার্সাল</h4>{" "}
      <ul>
        {" "}
        <li>
          একবার অনুমোদিত ও সম্পন্ন হওয়া লেনদেন শুধুমাত্র বিশেষ পরিস্থিতিতে
          রিভার্স করা যেতে পারে।
        </li>{" "}
        <li>
          নিম্নলিখিত ক্ষেত্রে এসটি পে লেনদেন রিভার্স করতে পারবে:{" "}
          <ul>
            {" "}
            <li>
              সিস্টেমের ত্রুটির কারণে ডুপ্লিকেট বা দুর্ঘটনাজনিত লেনদেন;
            </li>{" "}
            <li>প্রমাণিত প্রতারণামূলক বা অনুমোদনহীন লেনদেন;</li>{" "}
            <li>নিয়ন্ত্রক বা আইনগত সংস্থার নির্দেশ;</li>{" "}
            <li>
              মার্চেন্ট থেকে সেবা না পাওয়ার ক্ষেত্রে বৈধ বিরোধ নিষ্পত্তি
              প্রক্রিয়ার ভিত্তিতে।
            </li>{" "}
          </ul>{" "}
        </li>{" "}
        <li>
          ব্যবহারকারীকে লেনদেনের ২৪ ঘন্টার মধ্যে বৈধ তথ্য ও প্রমাণসহ রিভার্সাল
          রিকোয়েস্ট জানাতে হবে।
        </li>{" "}
        <li>
          প্রয়োজনীয় শর্ত পূরণ না হলে এসটি পে রিভার্সাল রিকোয়েস্ট বাতিল করতে
          পারবে।
        </li>{" "}
        <li>
          এসটি পে তৃতীয় পক্ষের মার্চেন্ট বা সেবাদাতার ক্ষেত্রে রিভার্সালের জন্য
          দায়ী নয় যদি না সমস্যাটি সরাসরি এসটি পে সিস্টেমের ত্রুটির কারণে হয়ে
          থাকে।
        </li>{" "}
      </ul>{" "}
      <h4>১৪. ফি ও চার্জ</h4>{" "}
      <ul>
        {" "}
        <li>
          এসটি পে সেবা ব্যবহারের জন্য সার্ভিস চার্জ, লেনদেন ফি বা প্রক্রিয়াকরণ
          ফি নিতে পারে। লেনদেনে অগ্রসর হওয়ার মাধ্যমে ব্যবহারকারী প্রযোজ্য
          চার্জের সাথে সম্মত বলে ধরা হবে।
        </li>{" "}
        <li>
          এসটি পে যে কোনো সময় ফি প্রবর্তন, পরিবর্তন, সংশোধন বা মওকুফ করার অধিকার
          সংরক্ষণ করে।
        </li>{" "}
        <li>
          লেনদেন নিশ্চিত করার আগে প্রযোজ্য চার্জ যাচাই করা ব্যবহারকারীর
          দায়িত্ব। প্রদর্শিত চার্জ না জানার কারণে কোনো অভিযোগ গ্রহণযোগ্য হবে
          না।
        </li>{" "}
      </ul>{" "}
      <h4>১৫. নীরব ও নিষ্ক্রিয় অ্যাকাউন্ট</h4>{" "}
      <ul>
        {" "}
        <li>
          ৩৬ মাসের বেশি সময় নিষ্ক্রিয় থাকা অ্যাকাউন্ট নীরব হিসেবে চিহ্নিত হতে
          পারে।
        </li>{" "}
        <li>পুনরায় চালু করতে পুনঃযাচাই প্রয়োজন হতে পারে।</li>{" "}
        <li>
          এসটি পে নিয়ন্ত্রক নির্দেশনা অনুযায়ী নীরব অ্যাকাউন্ট বন্ধ করার অধিকার
          রাখে।
        </li>{" "}
      </ul>{" "}
      <h4>১৬. যোগাযোগ ও নোটিফিকেশন</h4>{" "}
      <ul>
        {" "}
        <li>
          আপনি ইমেইল, এসএমএস, পুশ নোটিফিকেশন বা ইন-অ্যাপ মেসেজের মাধ্যমে যোগাযোগ
          পেতে সম্মত হচ্ছেন।
        </li>{" "}
        <li>আপনার যোগাযোগের তথ্য আপডেট রাখা আপনার দায়িত্ব।</li>{" "}
      </ul>{" "}
      <h4>১৭. শর্তাবলী পরিবর্তন</h4>{" "}
      <ul>
        {" "}
        <li>
          এসটি পে যে কোনো সময় শর্তাবলী পরিবর্তন, সংশোধন বা হালনাগাদ করার অধিকার
          সংরক্ষণ করে।
        </li>{" "}
        <li>
          যে কোনো পরিবর্তন এসটি পে প্ল্যাটফর্মে প্রকাশের সাথে সাথেই কার্যকর হবে।
        </li>{" "}
        <li>
          পরিবর্তনের পর সেবা ব্যবহারের মাধ্যমে আপনি সংশোধিত শর্তাবলীর সাথে সম্মত
          হচ্ছেন বলে বিবেচিত হবে।
        </li>{" "}
        <li>আপনাকে নিয়মিত শর্তাবলী পর্যালোচনা করার দায়িত্ব নিতে হবে।</li>{" "}
      </ul>{" "}
      <h4>১৮. দায়সীমা সীমাবদ্ধতা</h4>{" "}
      <ul>
        {" "}
        <li>
          এসটি পে কোনো প্রকার পরোক্ষ, বিশেষ বা ফলস্বরূপ ক্ষতির জন্য দায়ী নয়।
        </li>{" "}
        <li>
          যাচাইকৃত পরিস্থিতিতে শুধুমাত্র বিতর্কিত লেনদেনের আসল অর্থের সীমার
          মধ্যে দায়সীমা সীমাবদ্ধ থাকবে।
        </li>{" "}
      </ul>{" "}
      <h4>১৯. ফোর্স মাজিউর</h4> <p>নিম্নলিখিত কারণে এসটি পে দায়ী থাকবে না:</p>{" "}
      <ul>
        {" "}
        <li>প্রাকৃতিক দুর্যোগ, যুদ্ধ বা সরকারি কার্যক্রম;</li>{" "}
        <li>নিয়ন্ত্রক পরিবর্তন;</li>{" "}
        <li>সাইবার আক্রমণ, সিস্টেম ত্রুটি বা নেটওয়ার্ক সমস্যা;</li>{" "}
        <li>এসটি পে এর নিয়ন্ত্রণের বাইরে ফোর্স মাজিউর ঘটনা।</li>{" "}
      </ul>{" "}
      <h4>২০. নিয়ন্ত্রক ও ISO কমপ্লায়েন্স</h4>{" "}
      <ul>
        {" "}
        <li>এসটি পে বাংলাদেশ ব্যাংকের PSP লাইসেন্সপ্রাপ্ত।</li>{" "}
        <li>
          সেবা নিয়ন্ত্রক তত্ত্বাবধানে পরিচালিত হয় এবং নিম্নলিখিত মান অনুসরণ
          করে:{" "}
          <ul>
            {" "}
            <li>
              ISO/IEC 27001:2022 (ইনফরমেশন সিকিউরিটি ম্যানেজমেন্ট সিস্টেম)
            </li>{" "}
          </ul>{" "}
        </li>{" "}
        <li>
          সকল কার্যক্রম AML, CFT এবং ডাটা সিকিউরিটি অনুযায়ী পর্যবেক্ষণ করা হয়।
        </li>{" "}
      </ul>{" "}
      <h4>২১. ক্ষতিপূরণ</h4>{" "}
      <p>
        {" "}
        এসটি পে এর সেবা ব্যবহারের ক্ষেত্রে, আপনি এসটি পে, এর সহযোগী, কর্মকর্তা,
        কর্মচারী এবং অংশীদারদের ক্ষতিপূরণ দিতে, রক্ষা করতে এবং দায়মুক্ত রাখতে
        সম্মত হচ্ছেন যদি:{" "}
      </p>{" "}
      <ul>
        {" "}
        <li>আপনার দ্বারা প্ল্যাটফর্মের অপব্যবহার ঘটে;</li>{" "}
        <li>এই শর্তাবলী বা প্রযোজ্য আইনের লঙ্ঘন ঘটে;</li>{" "}
        <li>
          আপনার অবহেলার কারণে অনুমোদনহীন প্রবেশ বা তৃতীয় পক্ষের কোনো কার্যক্রম
          ঘটে;
        </li>{" "}
        <li>
          তৃতীয় পক্ষের কোনো বুদ্ধিবৃত্তিক সম্পত্তি বা গোপনীয়তা লঙ্ঘিত হয়;
        </li>{" "}
        <li>
          আপনার অ্যাকাউন্ট ব্যবহার করে যেকোনো লেনদেন বা নির্দেশনা সম্পাদিত হয়,
          তা অনুমোদিত হোক বা না হোক;
        </li>{" "}
        <li>আপনার কারণে গোপন বা সংবেদনশীল তথ্য ফাঁস হয়।</li>{" "}
      </ul>{" "}
      <h4>২২. আইন ও বিচারব্যবস্থা</h4>{" "}
      <p>
        {" "}
        এই শর্তাবলী গণপ্রজাতন্ত্রী বাংলাদেশের আইন দ্বারা পরিচালিত হবে। কোনো
        বিরোধের ক্ষেত্রে ঢাকা, বাংলাদেশের আদালতের একমাত্র বিচারব্যবস্থা প্রযোজ্য
        হবে।{" "}
      </p>{" "}
      <h4>২৩. ডাটা প্রাইভেসি ও সুরক্ষা</h4>{" "}
      <ul>
        {" "}
        <li>
          ব্যবহারকারীর ডাটা এসটি পে এর প্রাইভেসি নীতির অধীনে সংগ্রহ ও
          প্রক্রিয়াজাত করা হয়।
        </li>{" "}
        <li>আইন অনুযায়ী সরকারের সাথে ডাটা শেয়ার করা হতে পারে।</li>{" "}
        <li>
          এসটি পে ISO মান অনুসারে ইন্ডাস্ট্রি-গ্রেড এনক্রিপশন ও ডাটা সিকিউরিটি
          ব্যবহার করে।
        </li>{" "}
      </ul>{" "}
      <h4>২৪. গ্রাহকের ঝুঁকি, দায়িত্ব এবং দায়িত্বশীলতা</h4>
      <ul style={{ marginTop: "-10px" }}>
        <li>
          গ্রাহকের ঝুঁকি 
          <ul style={{ marginBlock: "10px" }}>
            <li>
              এসটি পে সেবা ব্যবহারের সঙ্গে কিছু অন্তর্নিহিত ডিজিটাল আর্থিক ঝুঁকি জড়িত থাকতে পারে, যেমন অননুমোদিত প্রবেশ, প্রযুক্তিগত ত্রুটি বা লেনদেন প্রক্রিয়ায় বিলম্ব।
            </li>
            <li>
              এসটি পে প্রয়োজনীয় নিরাপত্তা ব্যবস্থা গ্রহণ করে; তবে গ্রাহকদের এসব ঝুঁকি সম্পর্কে সচেতন থেকে সতর্কতার সঙ্গে সেবা ব্যবহার করতে হবে।
            </li>
          </ul>
        </li>
        <li>
          গ্রাহকের দায়িত্ব 
          <ul style={{ marginBlock: "10px" }}>
            <li>
              ব্যবহারের জন্য ব্যবহৃত আপনার পরিচয়সংক্রান্ত তথ্য (পিন,ওটিপি) এবং ডিভাইস নিরাপদে সংরক্ষণ করা।
            </li>
            <li>
              নিয়মিতভাবে অ্যাকাউন্ট কার্যক্রম পর্যালোচনা করা এবং কোনো অননুমোদিত লেনদেন শনাক্ত হলে দ্রুত রিপোর্ট করা।
            </li>
            <li>
              ওয়ালেট বা অন্যান্য সেবা ব্যবহারের ক্ষেত্রে এসটি পে-এর নীতিমালা ও নির্দেশনা অনুসরণ করা।
            </li>
          </ul>
        </li>
        <li>
          গ্রাহকের দায়বদ্ধতা 
          <ul style={{ marginBlock: "10px" }}>
            <li>
              গ্রাহকের পরিচয়সংক্রান্ত তথ্য ব্যবহার করে সম্পন্ন সকল লেনদেনের জন্য গ্রাহক দায়বদ্ধ থাকবেন, যদি না অননুমোদিত ব্যবহারের বিষয়টি সময়মতো রিপোর্ট করা হয়।
            </li>
            <li>
              এসটি পে-এর দায় কেবলমাত্র সিস্টেমজনিত ত্রুটি বা এসটি পে-এর অবহেলার ক্ষেত্রে সীমাবদ্ধ থাকবে, যা এই শর্তাবলীতে উল্লেখ করা হয়েছে।
            </li>
          </ul>
        </li>
        <li>
          বিরোধ ও অভিযোগ নিষ্পত্তি 
          <ul style={{ marginBlock: "10px" }}>
            <li>
              গ্রাহকরা ইমেইল, ফোন বা ইন-অ্যাপ সাপোর্টসহ এসটি পে-এর নির্ধারিত অফিসিয়াল চ্যানেলের মাধ্যমে অভিযোগ জানাতে পারবেন।
            </li>
            <li>
              এসটি পে তার অভিযোগ নিষ্পত্তি প্রক্রিয়া অনুযায়ী অভিযোগ তদন্ত ও সমাধান করবে।
            </li>
          </ul>
        </li>
      </ul>
      
      <h4>২৫. বুদ্ধিবৃত্তিক সম্পত্তি</h4>{" "}
      <ul>
        {" "}
        <li>
          এসটি পে এর সমস্ত লোগো, ট্রেডমার্ক, কনটেন্ট এবং প্রযুক্তি কোম্পানির
          বুদ্ধিবৃত্তিক সম্পত্তি।
        </li>{" "}
        <li>
          আপনি কোনো অংশ কপি, রিভার্স-ইঞ্জিনিয়ার বা বাণিজ্যিকভাবে ব্যবহার করতে
          পারবেন না।
        </li>{" "}
      </ul>{" "}

      <h4>২৬. অ্যাকাউন্ট বন্ধকরণ</h4>{" "}
      <ul>
        {" "}
        <li>
          আপনার কোনো বকেয়া না থাকলে অ্যাকাউন্ট বন্ধের জন্য অনুরোধ করতে পারবেন।
          অ্যাকাউন্ট বন্ধের জন্য আপনার NID সহ এসটি পে কর্পোরেট অফিসে যেতে হবে।
          আমাদের টিম অ্যাকাউন্ট বন্ধে সহায়তা করবে। অ্যাকাউন্ট বন্ধের পর আপনার
          তথ্য বাংলাদেশ ব্যাংক এবং দেশের প্রযোজ্য আইনের সাথে সামঞ্জস্য রেখে
          সংরক্ষণ ও মুছে ফেলা হবে।
        </li>{" "}
        <li>
          প্রতারণা, নন-কমপ্লায়েন্স বা নিষ্ক্রিয়তার কারণে এসটি পে আপনার
          অ্যাকাউন্ট বন্ধ করার অধিকার সংরক্ষণ করে।
        </li>{" "}
      </ul>

      {/* Limit / Annexure */}
      <h4>সংযুক্তি ‘ক’</h4>
      <table className="myTable">
        <tbody>
          <tr>
            <th colSpan="3" className={classes.center}>
              লেনদেনের সীমা (ব্যক্তিগত ওয়ালেট)
            </th>
          </tr>
          <tr>
            <td>ক্রমিক নং</td>
            <td>বিবরণ</td>
            <td>পরিমান (টাকায়)</td>
          </tr>
          <tr>
            <td>১</td>
            <td>যে কোন সময়ে সর্বোচ্চ ব্যালেন্স</td>
            <td>৪,০০,০০০</td>
          </tr>
          <tr>
            <td>২</td>
            <td>প্রতি লেনদেনে যেকোনো চ্যানেলের মাধ্যমে অর্থ যোগ করুন</td>
            <td>১,০০,০০০</td>
          </tr>
          <tr>
            <td>৩</td>
            <td>প্রতিদিন যে কোনো চ্যানেল মাধ্যমে টাকা যোগ করুন</td>
            <td>৪,০০,০০০</td>
          </tr>
          <tr>
            <td>৪</td>
            <td>প্রতি মাসে টাকা যোগ করুন</td>
            <td>৪,০০,০০০</td>
          </tr>

          <tr>
            <th>৫</th>
            <th colSpan="2">অর্থপ্রদান (ই-কম/মেক পেমেন্ট)</th>
          </tr>
          <tr>
            <td></td>
            <td> - প্রতি লেনদেনের সীমা</td>
            <td>৪,০০,০০০</td>
          </tr>
          <tr>
            <td></td>
            <td> - দৈনিক লেনদেনের সীমা</td>
            <td>৪,০০,০০০</td>
          </tr>
          <tr>
            <td></td>
            <td> - মাসিক লেনদেনের সীমা</td>
            <td>৪,০০,০০০</td>
          </tr>

          <tr>
            <th>৬</th>
            <th colSpan="2">টাকা পাঠান</th>
          </tr>
          <tr>
            <td></td>
            <td> - প্রতি লেনদেনের সীমা</td>
            <td>৫০,০০০</td>
          </tr>
          <tr>
            <td></td>
            <td> - দৈনিক লেনদেনের সীমা</td>
            <td>১,০০,০০০</td>
          </tr>
          <tr>
            <td></td>
            <td> - মাসিক লেনদেনের সীমা</td>
            <td>৪,০০,০০০</td>
          </tr>
          <tr>
            <th>৭</th>
            <th colSpan="2">ব্যাংক ট্রান্সফার</th>
          </tr>
          <tr>
            <td></td>
            <td> - প্রতি লেনদেনের সীমা</td>
            <td>৫০,০০০</td>
          </tr>
          <tr>
            <td></td>
            <td> - দৈনিক লেনদেনের সীমা</td>
            <td>৫০,০০০</td>
          </tr>
          <tr>
            <td></td>
            <td> - মাসিক লেনদেনের সীমা</td>
            <td>৪,০০,০০০</td>
          </tr>

          <tr>
            <th>৮</th>
            <th colSpan="2">ভিসা ডেবিট কার্ড ফান্ড ট্রান্সফার (তাৎক্ষণিক)</th>
          </tr>
          <tr>
            <td></td>
            <td> - প্রতি লেনদেনের সীমা</td>
            <td>৫০,০০০</td>
          </tr>
          <tr>
            <td></td>
            <td> - দৈনিক লেনদেনের সীমা</td>
            <td>৫০,০০০</td>
          </tr>
          <tr>
            <td></td>
            <td> - মাসিক লেনদেনের সীমা</td>
            <td>৪,০০,০০০</td>
          </tr>
        </tbody>
      </table>
      <p>
        দ্রষ্টব্য: 
        <br />
        * এসটি পে তার বিবেচনার ভিত্তিতে সীমা কাঠামো পরিবর্তন করার অধিকার সংরক্ষণ করে।
        <br />
        * এসটি পে ব্যবহারকারী ১ থেকে ৩ কার্যদিবসের মধ্যে "ব্যাংক ট্রান্সফার" এর মাধ্যমে টাকা পাবেন।
        <br />
        * প্রতি লেনদেনে ন্যূনতম এবং সর্বোচ্চ অ্যাড মানি সীমা নির্বাচিত চ্যানেলের উপর ভিত্তি করে ভিন্ন হতে পারে।
      </p>
      <h4>সংযুক্তি খ</h4>
      <table className="myTable">
        <tbody>
          <tr>
            <th colSpan="3" className={classes.center}>
              লেনদেন ফি (ব্যক্তিগত ওয়ালেট)
            </th>
          </tr>
          <tr>
            <td className={classes.center}>সার্ভিস</td>
            <td className={classes.center}>ফি/চার্জ (ভ্যাটসহ)</td>
          </tr>
          <tr>
            <td>নিবন্ধন</td>
            <td>ফ্রি</td>
          </tr>
          <tr>
            <td>অ্যাকাউন্ট রক্ষণাবেক্ষণ</td>
            <td>ফ্রি</td>
          </tr>
          <tr>
            <td>ব্যাংক অ্যাকাউন্ট আনলিঙ্ক করুন</td>
            <td>ফ্রি</td>
          </tr>
          <tr>
            <td>ইউটিলিটি বিল পেমেন্ট</td>
            <td>ফ্রি</td>
          </tr>
          <tr>
            <td>ক্রেডিট কার্ড বিল পেমেন্ট</td>
            <td>১%</td>
          </tr>
          <tr>
            <td>ডেবিট/ক্রেডিট কার্ড থেকে অর্থ যোগ করুন</td>
            <td>ফ্রি</td>
          </tr>
          <tr>
            <td>ব্যাংক থেকে টাকা যোগ করুন</td>
            <td>ফ্রি</td>
          </tr>
          <tr>
            <td>ব্যাংকে অর্থ স্থানান্তর করুন</td>
            <td>১%</td>
          </tr>
          <tr>
            <td>টাকা পাঠান (ওয়ালেট থেকে ওয়ালেট)</td>
            <td>ফ্রি</td>
          </tr>
          <tr>
            <td>টাকা গ্রহণ (ওয়ালেট থেকে ওয়ালেট)</td>
            <td>ফ্রি</td>
          </tr>
          <tr>
            <td>মোবাইল রিচার্জ</td>
            <td>ফ্রি</td>
          </tr>
          <tr>
            <td>QR কোড পেমেন্ট</td>
            <td>ফ্রি</td>
          </tr>
          <tr>
            <td>লেনদেনের ইতিহাস</td>
            <td>ফ্রি</td>
          </tr>
          <tr>
            <td>ব্যাংক ক্যাশ আউট (সর্বনিম্ন উত্তোলনের পরিমাণ ১০০ টাকা)</td>
            <td>১%</td>
          </tr>
          <tr>
            <td>ভিসা ডেবিট কার্ড ফান্ড ট্রান্সফার (তাৎক্ষণিক)</td>
            <td>১.৫%</td>
          </tr>
        </tbody>
      </table>
      <p>
        * এসটি পে তার বিবেচনার ভিত্তিতে ফি কাঠামো পরিবর্তন করার অধিকার সংরক্ষণ
        করে।
      </p>
      <br />
      <style>
        {`
        .myTable:nth-of-type(1) > tbody > tr > td:nth-of-type(1), 
            .myTable:nth-of-type(1) > tbody > tr > td:last-of-type, 
            .myTable:nth-of-type(1) > tbody > tr > th:nth-of-type(1) {
              text-align: center;
              font-weight: 600;
            }


            .myTable:nth-of-type(2) > tbody > tr > td:last-of-type {
              text-align: center;
            }`}
      </style>
    </div>
  );
};

export default PersonalTCBangla;
